import { formatearFechaConHora, formatearFechaSinHora } from "@shared/utils/date.utils";
import IEstado from "./estado.interface";
import IExpediente, { IApelacion, IPorcentajesDocumentos } from "./expediente.interface";
import { Prestador } from "./prestador.model";
import IRegion from "./region.interface";
import IMotivo from "./motivo.interface";
import { Sancion } from "./sancion.model";

export class Expediente implements IExpediente {
    id: number;
    cantidad_licencias: number;
    fecha_cohorte: string;
    fecha_creacion: string;
    fecha_termino: string;
    region: IRegion;
    prestador: Prestador;
    estado: IEstado;
    exp_cierra_expediente: string;
    sancion: Sancion;
    porcentajesDocumentos: IPorcentajesDocumentos;
    motivo: IMotivo;
    iteracion: number;
    apelacion: IApelacion;
    dias_habiles: number;
    cumplimiento: number;
    estado_revision: number;
    devoluciones: number;

    get porcentaje_cumplimiento(): string {
        return Number.isInteger(this.cumplimiento) ? this.cumplimiento + "%" : "";
    }

    getFechaCreacion() {
        return formatearFechaConHora(this.fecha_creacion);
    }

    getFechaCreacionSinHora() {
        return formatearFechaSinHora(this.fecha_creacion);
    }

    getFechaTermino() {
        return formatearFechaConHora(this.fecha_termino);
    }

    getFechaTerminoSinHora() {
        return formatearFechaSinHora(this.fecha_termino);
    }

    getFechaTerminoSinHoraConBarras() {
        return this.getFechaTerminoSinHora().replace(/-/g, "/");
    }

    getFechaCohorte() {
        return formatearFechaConHora(this.fecha_cohorte);
    }

    getFechaCohorteSinHora() {
        return formatearFechaSinHora(this.fecha_cohorte);
    }

    getCierreExpediente() {
        return this.exp_cierra_expediente === 'SI';
    }
}